import { useState, useEffect } from "react";
import { toast } from "sonner";

/**
 * Custom hook to handle payment status after 3DS redirect
 * Shows processing state and refreshes data after webhook processes
 */
export function usePaymentStatus({ onSuccess }) {
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingMessage, setProcessingMessage] = useState(null);

    // Check URL params on mount
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const paymentStatus = urlParams.get("payment_status");
        const platform = urlParams.get("platform");

        if (paymentStatus === "processing") {
            setIsProcessing(true);
            setProcessingMessage("Processing your payment...");

            // Give webhook time to process (usually instant, but wait a bit)
            setTimeout(() => {
                setProcessingMessage("Payment successful!");
                toast.success("Payment completed! Your credits have been added.");
                setIsProcessing(false);

                // Notify parent to refresh data
                if (onSuccess) {
                    onSuccess({ platform });
                }
            }, 2000);

            // Clean up URL
            const url = new URL(window.location);
            url.searchParams.delete("payment_status");
            url.searchParams.delete("platform");
            window.history.replaceState({}, "", url);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        isProcessing,
        processingMessage,
    };
}
